import { useMemo } from "react"

export const useDataAttributes = (dataAttributes?: Record<string, string | number | boolean>) => {
	return useMemo(() => {
		if (!dataAttributes) return {}

		return Object.entries(dataAttributes).reduce(
			(acc, [key, value]) => {
				const dataKey = key.startsWith("data-") ? key : `data-${key}`
				acc[dataKey] = value
				return acc
			},
			{} as Record<string, string | number | boolean>
		)
	}, [dataAttributes])
}
